import { CountryCode } from 'libphonenumber-js';

type Locale = {
  [keys: string]: { lang: string; display: string; iti: Iti };
};

type Iti = {
  display: string;
  areaCode: string;
  country: string;
  iti: CountryCode;
};

const availableLocales: Locale = {
  'zh-TW': {
    lang: 'zh-tw',
    display: '繁體中文',
    iti: { display: 'TW+886', areaCode: '+886', country: 'tw', iti: 'TW' },
  },
  'zh-CN': {
    lang: 'zh-cn',
    display: '中文(中國)',
    iti: { display: 'CN+86', areaCode: '+86', country: 'cn', iti: 'CN' },
  },
  'en-US': {
    lang: 'en-us',
    display: 'English',
    iti: { display: 'US+1', areaCode: '+1', country: 'us', iti: 'US' },
  },
  ja: {
    lang: 'ja-jp',
    display: '日本語',
    iti: { display: 'JA+81', areaCode: '+81', country: 'jp', iti: 'JP' },
  },
  ko: {
    lang: 'ko-kr',
    display: '한국어',
    iti: { display: 'KR+82', areaCode: '+82', country: 'kr', iti: 'KR' },
  },
  th: {
    lang: 'th-th',
    display: 'ภาษาไทย',
    iti: { display: 'TH+66', areaCode: '+66', country: 'th', iti: 'TH' },
  },
  vi: {
    lang: 'vi-vn',
    display: 'Tiếng Việt',
    iti: { display: 'VI+84', areaCode: '+84', country: 'vn', iti: 'VN' },
  },
  ms: {
    lang: 'ms-my',
    display: 'Bahasa Melayu',
    iti: { display: 'MY+60', areaCode: '+60', country: 'my', iti: 'MY' },
  },
  sr: {
    lang: 'sr-rs',
    display: 'српски',
    iti: { display: 'SR+381', areaCode: '+381', country: 'rs', iti: 'RS' },
  },
  'de-AT': {
    lang: 'de-at',
    display: 'Österreich',
    iti: { display: 'AT+43', areaCode: '+43', country: 'at', iti: 'AT' },
  },
  'de-DE': {
    lang: 'de-de',
    display: 'Deutsch',
    iti: { display: 'DE+49', areaCode: '+49', country: 'de', iti: 'DE' },
  },
  'zh-HK': {
    lang: 'zh-hk',
    display: '繁體中文(香港)',
    iti: { display: 'HK+852', areaCode: '+852', country: 'hk', iti: 'HK' },
  },
  'es-rES': {
    lang: 'es-es',
    display: 'Español (España)',
    iti: { display: 'ES+34', areaCode: '+34', country: 'es', iti: 'ES' },
  },
  'fr-FR': {
    lang: 'fr-fr',
    display: 'Français',
    iti: { display: 'FR+33', areaCode: '+33', country: 'fr', iti: 'FR' },
  },
};

export { availableLocales };
export type { Iti };
